export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  stringFilter(state) {
    let filter = 'entidade is not null';
    if (state.searchText) {
      filter += ` and (descricao like '%${state.searchText.toLowerCase()}%' or codigo like '%${state.searchText.toLowerCase()}%')`;
    }
    return filter;
  },
};
